import React from 'react'
import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {useTranslation} from '@modifi/plugin-i18n'
import {TradePartnerApprovalStatus} from '@modifi/enums'

import {OnboardingStatusTag} from '@modifi/ui'

import {ROUTE_COMPANY_TRADE_PARTNERS_BY_ID} from '../../../routes/constants'
import {selectSellerTradePartners} from '../../../data/seller-trade-partners'
import {STATUS_MAPPING} from '../constants'
import {getBuyerLimitForTable} from '../../intro/pre-underwriting-form/buyer-details/buyer-list/selector'

type StatusTagProps = {
  status: TradePartnerApprovalStatus
}

const StatusTag: React.FC<StatusTagProps> = ({status}) => {
  const {t} = useTranslation('charon')
  const updatedStatus =
    status === TradePartnerApprovalStatus.LIMIT_AVAILABLE
      ? TradePartnerApprovalStatus.PENDING
      : status
  return (
    <OnboardingStatusTag status={STATUS_MAPPING[status]}>
      {t(`seller-trade-partner.approval-status.${updatedStatus}`)}
    </OnboardingStatusTag>
  )
}

export default StatusTag

/** One row of the trade-partner summary table. */
export type TradePartnerSummaryEntry = {
  route: string
  name: string
  approvalStatus: React.ReactNode
  allocatedLimit: string | number
}

export const selectTradePartnerSummaryData = createSelector(
  selectSellerTradePartners,
  tradePartners => {
    const summaryData = tradePartners.map(tradePartner => {
      const name = tradePartner?.tradePartnerCompany?.address?.companyName || ''
      return {
        route: generatePath(ROUTE_COMPANY_TRADE_PARTNERS_BY_ID, {
          externalId: tradePartner?.tradePartnerCompany?.externalCompanyId || '',
        }),
        name,
        approvalStatus: tradePartner?.tradePartnerApproval?.status ? (
          <StatusTag
            status={tradePartner?.tradePartnerApproval?.status as TradePartnerApprovalStatus}
          />
        ) : (
          ''
        ),
        allocatedLimit: getBuyerLimitForTable(tradePartner),
      }
    })
    return summaryData
  }
)

export const selectAreAllBsrsDeclined = createSelector(
  selectSellerTradePartners,
  tradePartners =>
    tradePartners &&
    tradePartners?.length > 0 &&
    tradePartners.every(
      tradePartner =>
        tradePartner.tradePartnerApproval?.status === TradePartnerApprovalStatus.DECLINED
    )
)
